import React from 'react';
import PropTypes from 'prop-types';
import { socialTypes } from './enums';
import SocialPostInstagram from './social-post-instagram';
import SocialPostTwitter from './social-post-twitter';
import SocialPostTikTok from './social-post-tiktok';
import SocialPostYouTube from './social-post-youtube';

const SocialPost = ({ model, socialType }) => {

    return (
        <>
            {
                socialType === socialTypes.INSTAGRAM && <SocialPostInstagram model={model} />
            }
            {
                socialType === socialTypes.TWITTER && <SocialPostTwitter model={model} />
            }
            {
                socialType === socialTypes.TIKTOK && <SocialPostTikTok model={model} />
            }
            {
                socialType === socialTypes.YOUTUBE && <SocialPostYouTube model={model} />
            }
        </>
    );
};

SocialPost.propTypes = {
    model: PropTypes.object.isRequired
};

export default SocialPost;
